import CloseIcon from '@mui/icons-material/Close';
import MenuIcon from '@mui/icons-material/Menu';
import { Box, Drawer, IconButton, List } from '@mui/material';
import Grid from '@mui/material/Grid';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItem from '@mui/material/ListItem';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { constants } from '../../constants';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';
import useMyMApi from "../../hooks/useMyMApi";
import useWebContext from '../../hooks/useWebContext';
import { AuthUserContext } from '../../provider/AuthUserContextProvider';
import { NotifyContext } from '../../provider/NotifyContextProvider';
import { MyMImage } from '../../ui-elements/MyMImage';
import { MyMBlackLink } from '../../ui-elements/MyMLink';
import { MyMProgress } from '../../ui-elements/MyMProgress';
import { MyMTooltip } from '../../ui-elements/MyMToolTip';
import { MenuBar } from '../../ui-parts/MenuBar';
import { HamburgerMenuItem } from '../../ui-parts/MenuNavItem';
import { NavigateLink } from '../../ui-parts/NavigateLink';
import SearchBar from '../../ui-parts/SearchBar';
import { utility } from '../../utility';
import { HeaderBarSurveyNotify, HeaderBarUserNotify } from './HeaderBarNotify';
import { FooterMenuItems } from '../MyM902_Footer/FooterBar';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import LogoutIcon from '@mui/icons-material/Logout';



/**
 * HeaderBar Component
 * @param {object} param0 - コンポーネントプロパティ
 * @param {object} param0.controlSettings - controlSettings定義
 * @param {string} param0.screenId - 画面ID
 */
const HeaderBar = ({ controlSettings, screenId }) => {
  const isPc = useMediaQuery(mediaQuery.pc);
  return (
    isPc
      ?
      <MenuBar>
        {/* 2025.7.7 MyMine Version3.0対応 Modify Start */}
        <HeaderBarGridMenuItem controlSettings={controlSettings} screenId={screenId} />
        <HeaderBarGridSearchbarItem searchText={controlSettings.LabelList.btnSearch} screenId={screenId} />
        <HeaderIconItems controlSettings={controlSettings} screenId={screenId} />
        {/* 2025.7.7 MyMine Version3.0対応 Modify End */}
      </MenuBar>
      :
      <MenuBar>
        <HeaderBarGridMenuItem controlSettings={controlSettings} screenId={screenId} />
        <HeaderIconItems controlSettings={controlSettings} screenId={screenId} />
        <HeaderBarGridSearchbarItem searchText={controlSettings.LabelList.btnSearch} screenId={screenId} />
      </MenuBar>
  );
}
export default HeaderBar;

// 2024.9.16 MyMine Version2.0対応 Modify Start
// Mobile/Tablet表示対応の対応のため、コンポーネント部品を切り出し・追加
/**
 * ヘッダGridメニューアイテム
 */
const HeaderBarGridMenuItem = (props) => {
  const { controlSettings, screenId, } = props;
  const isPc = useMediaQuery(mediaQuery.pc);
  // 2025.7.7 MyMine Version3.0対応 Add Start
  const [isOpenHamburgerMenu, setIsOpenHamburgerMenu] = useState(false);
  function openHamburgerMenu() { setIsOpenHamburgerMenu(true); }
  function closeHamburgerMenu() { setIsOpenHamburgerMenu(false); }
  // 2025.7.7 MyMine Version3.0対応 Add End

  return (
    <Grid item xs={2} sm={2} md={2} lg={3}
      // 2024.12.23 MyMine Version2.1対応 Add Start
      className='d-flex align-items-center'
    // 2024.12.23 MyMine Version2.1対応 Add End
    >
      <>
        {/*2025.7.7 MyMine Version3.0対応 Add Start*/}
        <IconButton
          className='px-2'
          onClick={openHamburgerMenu}
        >
          <MenuIcon sx={{ fontSize: '35px', color: "white" }} />
        </IconButton>
        <Drawer sx={{ '& .MuiDrawer-paper': { maxHeight: { xs: '90%', lg: '90%' }, top: { xs: 80, xl: 115 } } }} anchor="left" open={isOpenHamburgerMenu} onClose={closeHamburgerMenu} >
          <Box>
            <Box sx={{ paddingBottom: '50px' }} />
            <IconButton onClick={closeHamburgerMenu} style={{ position: 'absolute', left: 1, top: 2 }} >
              <CloseIcon sx={{ fontSize: '35px' }} />
            </IconButton>
            <MyMLabel fontSize='25px' fontWeight='bold' className='d-flex justify-content-center'>{controlSettings.LabelList.lblMenuTitle}</MyMLabel>
            <List className='px-3'>
              <HeaderMenuItems isHamburger={true} handleClose={closeHamburgerMenu} screenId={screenId} />
              {!isPc &&
                <FooterMenuItems isHamburger={true} handleClose={closeHamburgerMenu} />
              }
            </List>
          </Box>
        </Drawer>
        {/*2025.7.7 MyMine Version3.0対応 Add Start*/}
      </>
    </Grid>
  );
}

// 2025.7.7 MyMine Version3.0対応 Add Start
/**
 * ヘッダアイコンアイテム
 */
const HeaderIconItems = (props) => {
  const { controlSettings, screenId, } = props;
  const { authUser, setAuthUser } = useContext(AuthUserContext);
  const [linkMenuAnchor, setLinkMenuAnchor] = useState(null);
  const openLinkMenu = Boolean(linkMenuAnchor);
  // 2025.7.7 MyMine Version3.0対応 Add Start
  const apiRequest = useMyMApi(screenId);
  const { notify, setNotify } = useContext(NotifyContext);
  // 2025.7.7 MyMine Version3.0対応 Add End

  // 2025.7.7 MyMine Version3.0対応 Add Start
  useEffect(() => {
    /**
     * 通知情報取得
     * @param {object} getNotifyUser 通知取得対象ユーザ情報
    */
    const getNotify = (getNotifyUser) => {
      const callbackRequestNotifySurvey = (result) => {
        setNotify(result);
      };
      // ログインユーザのロールがAdmin以外の場合、Survey通知も取得
      const needsGetSurveyNotify = getNotifyUser != null && getNotifyUser.RoleId !== constants.UserRole.Administrators;
      apiRequest.requestJson(`api/notification/user?needsGetSurveyNotify=${needsGetSurveyNotify}`, 'GET', callbackRequestNotifySurvey);
    }

    if (!authUser) {
      const callbackRequestAuthUser = (result) => {
        setAuthUser(result);
        getNotify(result);
      };
      apiRequest.requestJson('api/page/auth-user', 'GET', callbackRequestAuthUser);
    } else {
      getNotify(authUser);
    }
  }, [])
  // 2025.7.7 MyMine Version3.0対応 Add End

  /** MyPageメニューボタン押下時処理 */
  const onClickMyPageMenu = (e) => {
    setLinkMenuAnchor(e.currentTarget);
  };

  /** MyPageメニューClose処理 */
  const closeMyPageMenu = () => {
    setLinkMenuAnchor(null);
  }
  /** ログアウト処理 */
  const onClickLogout = () => {
    setAuthUser(null);
    utility.transferTopPage();
  }

  if (!authUser || !notify) {
    return <MyMProgress />
  }

  return (
    <Grid item xs={6} sm={6} md={3} lg={2} className="d-flex align-items-center justify-content-end" sx={{ marginLeft: 'auto' }}>
      <Grid item>
        <Box >
          {authUser.IsAvailableRequest === true &&
            <Box>
              <MyMTooltip
                title={controlSettings.LabelList.lblRequestBoardTooltip}

              >
                <NavigateLink to='/MyM705' newTabNavigate={true} isBlackTheme={true}>
                  <MyMImage screenId={screenId} filePath={controlSettings.ImageList.imgRequestBoard} />
                </NavigateLink>
              </MyMTooltip>
            </Box>
          }
        </Box>
      </Grid>
      <Grid item>
        <Box >
          <HeaderBarSurveyNotify screenId={screenId} controlSettings={controlSettings} notify={notify} setNotify={setNotify} />
        </Box>
      </Grid>
      <Grid item>
        <Box >
          <HeaderBarUserNotify screenId={screenId} controlSettings={controlSettings} userNotifyList={notify.UserNotifyList} />
        </Box>
      </Grid>
      <Grid item>
        <Box >
          <IconButton onClick={onClickMyPageMenu}>
            <MyMImage
              screenId={screenId}
              filePath={controlSettings.ImageList.imgMyPage}
              sx={{ fontSize: '35px' }} />
          </IconButton>
          <Menu
            anchorEl={linkMenuAnchor}
            open={openLinkMenu}
            onClose={closeMyPageMenu}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left', }}
            PaperProps={{
              sx: { backgroundColor: '#fff' }
            }}>
            <MenuItem onClick={closeMyPageMenu}>
              <NavigateLink to="/MyM102/MyM202" isBlackTheme={true}>{controlSettings.LabelList.lnkMyProfile}</NavigateLink>
            </MenuItem>
            <MenuItem onClick={closeMyPageMenu}>
              <MyMBlackLink onClick={onClickLogout}>{controlSettings.LabelList.lnkLogout}</MyMBlackLink>
            </MenuItem>
          </Menu>
        </Box>
      </Grid>
    </Grid>
  );
}
// 2025.7.7 MyMine Version3.0対応 Add End

/**
 * ヘッダGrid検索バーアイテム
 * @param {object} param0 - コンポーネントプロパティ
 * @param {object} param0.screenId - 画面ID
 * @param {string} param0.searchText - 検索ボタンラベルテキスト
 */
const HeaderBarGridSearchbarItem = ({ screenId, searchText }) => {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = useState('');
  const [isSearchbarInFocus, setIsSearchbarInFocus] = useState(false);
  const isThumbnailViewPage = useLocation().pathname === '/MyM102/MyM402';
  const [header, setHeader] = useState(null);
  const apiRequest = useMyMApi(screenId);
  // 2024.12.23 MyMine Version2.1対応 Add Start
  const [isAdvancedCheck, setIsAdvancedCheck] = useState(false);
  const { controlSettings } = useWebContext(screenId);
  // 2024.12.23 MyMine Version2.1対応 Add End
  // 2025.7.7 MyMine Version3.0対応 Add Start
  const isPc = useMediaQuery(mediaQuery.pc);
  // 2025.7.7 MyMine Version3.0対応 Add End

  useEffect(() => {
    const callbackRequestHeader = (result) => {
      setHeader(result);
    };
    apiRequest.requestJson('api/page/header', 'GET', callbackRequestHeader)
  }, []);

  const onSearch = () => {

    // 2024.12.23 MyMine Version2.1対応 Modify Start
    navigate(isThumbnailViewPage === true && isAdvancedCheck === false ? '/MyM102/MyM402' : '/MyM102/MyM401',
      {
        state:
        {
          searchValue: searchValue.trim(),
          // 2024.9.16 MyMine Version2.0対応 Add Start
          isLoadSearchKeyword: true,
          // 2024.9.16 MyMine Version2.0対応 Add End
          isAdvancedSearch: isAdvancedCheck && searchValue.trim() !== '' // AdvancedSearchチェックがOn 且つ キーワード入力時のみ、Advanced検索実施 
        }
      });
    // 2024.12.23 MyMine Version2.1対応 Modify End
  }

  return (
    <Grid item xs={12} sm={12} md={7} lg={7} className='d-flex align-items-center' sx={{ padding: '5px 3px' }}>
      <SearchBar
        textSx={
          {
            '&.MuiAutocomplete-root': {
              backgroundColor: isSearchbarInFocus ? 'white' : null,
              minWidth: isPc ? '60%' : '100%',
              '.MuiInputBase-input': {
                color: isSearchbarInFocus ? null : 'white',
              },
              'fieldset': {
                borderColor: 'white !important',
              },
            },
          }
        }
        onFocusSearchBar={() => setIsSearchbarInFocus(true)}
        onBlurSearchBar={() => setIsSearchbarInFocus(false)}
        onSearch={onSearch}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        optionList={header?.SearchKeywordList.map(keyword => ({ label: keyword }))}
        searchText={searchText}
        // 2024.12.23 MyMine Version2.1対応 Add Start
        controlSettings={controlSettings}
        isAdvancedCheck={isAdvancedCheck}
        setIsAdvancedCheck={setIsAdvancedCheck}
      // 2024.12.23 MyMine Version2.1対応 Add End
      />
    </Grid>
  );
};

/**
 * バーガーメニューヘッダ項目
 * @param {object} param0 - コンポーネントプロパティ
 * @param {function} param0.handleClose - メニューを閉じるための関数
 */
export const HeaderMenuItems = ({ handleClose, screenId }) => {

  // 2025.7.7 MyMine Version3.0対応 Add Start
  const { controlSettings, screenSettings } = useWebContext(screenId);
  const { setAuthUser } = useContext(AuthUserContext);
  const onClickLogout = () => {
    setAuthUser(null);
    utility.transferTopPage();
  };
  
  const isPc = useMediaQuery(mediaQuery.pc);
  // 2025.7.7 MyMine Version3.0対応 Add End

  const menuList =
    [
      { linkTo: '/MyM102', labelId: 'lnkHome' },
      { linkTo: '/MyM102/MyM301', labelId: 'lnkSales' },
      { linkTo: '/MyM102/MyM303', labelId: 'lnkService' },
      { linkTo: '/MyM102/MyM306', labelId: 'lnkSpecializedPartsServiceLevel1' },
      { linkTo: '/MyM102/MyM309', labelId: 'lnkDigitalSolutionLevel1' },
      { linkTo: '/MyM102/MyM313', labelId: 'lnkAHSLevel1' },
      { linkTo: '/MyM102/MyM317', labelId: 'lnkTrainingLevel1' },
      // 2025.7.7 MyMine Version3.0対応 Add Start
      ...(screenSettings.MarketInsightOnFlg === 1
        ? [{ linkTo: '/MyM102/MyM324', labelId: 'lnkMarketing' }]
        : []),
      { linkTo: '/MyM102/MyM325', labelId: 'lnkAssetLibrary' },
      { linkTo: '/MyM102/MyM305', labelId: 'lnkITApplication' },
      { linkTo: '/MyM102/MyM202', labelId: 'lnkMyProfile_Hamburger' },
      // 2025.7.7 MyMine Version3.0対応 Add EndEnd


    ];

  return (
    <>
    {menuList.map(menu => (
    <HamburgerMenuItem
      key={menu.labelId}
      handleClose={handleClose}
      menu={menu}
      menuText={controlSettings.LabelList[menu.labelId]}
      // 2025.7.7 MyMine Version3.0対応 Add Start
      screenId={screenId}
      controlSettings={controlSettings}
    // 2025.7.7 MyMine Version3.0対応 Add End
    />
    ))}
      {/*2025.7.7 MyMine Version3.0対応 Add Start*/}
      { isPc &&
        <ListItem
        sx={{
          height: 65,
          borderBottom: '1px solid #8080806e',
          ':hover': {
            cursor: 'pointer',
            textDecoration: 'underline',
            backgroundColor: '#DDDDDD',
          },
        }}
        onClick={() => {
          handleClose();
          onClickLogout()
        }}
      >
          <LogoutIcon />
          <MyMLabel fontWeight='bold' sx={{ paddingLeft: '5px' }}>{controlSettings.LabelList.lnkLogout_Hamburger}</MyMLabel>
      </ListItem>
      }
      {/*2025.7.7 MyMine Version3.0対応 Add End*/}
    </>
  );
}
// 2024.9.16 MyMine Version2.0対応 Modify End

